import { combineSlices, createSelector } from '@reduxjs/toolkit';
import type { AppState } from '@src/providers/AppStateProvider/types';
import { apiKeysSliceReducer, isApiKeysTabDirty } from './apiKeys/apiKeysSlice';
import { drawerSliceReducer } from './drawer/drawerSlice';
import { isPermissionsTabDirty, permissionsSliceReducer } from './permissions/permissionsSlice';
import { userDetailsSliceReducer } from './userDetails/userDetailsSlice';

export const customerUserSlice = combineSlices({
  drawer: drawerSliceReducer,
  userDetails: userDetailsSliceReducer,
  apiKeys: apiKeysSliceReducer,
  permissions: permissionsSliceReducer,
});

export interface TabDef {
  label: 'General' | 'Account Restrictions' | 'API Keys';
  isDirty: boolean;
}
export interface TabDefs {
  general: TabDef;
  permissions: TabDef;
  apiKeys: TabDef;
}

export const selectTabDefs = createSelector(
  (state: AppState) => state.customerUserDrawer,
  (state: AppState, enableCustomerAccountRestrictions: boolean) => enableCustomerAccountRestrictions,
  (customerUserDrawer, enableCustomerAccountRestrictions): TabDef[] => {
    const tabDefs: TabDef[] = [
      {
        label: 'General',
        isDirty: customerUserDrawer.userDetails.isDirty,
      },
    ];

    if (enableCustomerAccountRestrictions) {
      tabDefs.push({
        label: 'Account Restrictions',
        isDirty: isPermissionsTabDirty(customerUserDrawer.permissions),
      });
    }

    if (customerUserDrawer.userDetails.customerUserId) {
      tabDefs.push({
        label: 'API Keys',
        isDirty: isApiKeysTabDirty(customerUserDrawer.apiKeys),
      });
    }

    return tabDefs;
  }
);

export const selectIsDrawerDirty = (state: AppState, enableCustomerAccountRestrictions: boolean) => {
  return selectTabDefs(state, enableCustomerAccountRestrictions).some(tabDef => tabDef.isDirty);
};
